import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t, tKey } from 'ember-intl';
import importAsset from 'lumen/helpers/import-asset';
import type Highlight from 'lumen/models/roi-trophies/highlight';
import {
  HIGHLIGHT_PERIOD_TYPE,
  type RevenueGeneralData,
} from 'lumen/models/roi-trophies/highlight';
import lottieAnimation from 'lumen/modifiers/lottie-animation';

import GeneralRoiTrophiesCalendarDateLink from '../calendar-date-link';
import GeneralRoiTrophiesCountUpNumber from '../count-up-number';
import GeneralRoiTrophiesContentTrophyModalLayout from './trophy-modal-layout';

interface GeneralRoiTrophiesContentRevenueGeneralSignature {
  Args: {
    highlight: Highlight;
  };
}

export default class GeneralRoiTrophiesContentRevenueGeneral extends Component<GeneralRoiTrophiesContentRevenueGeneralSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get currency(): string {
    return this.hotelAndMarketService.hotel!.currencyCode;
  }

  get data(): RevenueGeneralData {
    return this.args.highlight.highlightData as RevenueGeneralData;
  }

  get sublineKey(): string {
    return this.args.highlight.periodType === HIGHLIGHT_PERIOD_TYPE.WEEK
      ? tKey('roi_trophies.revenue.subline_for_week')
      : tKey('roi_trophies.revenue.subline');
  }

  <template>
    <GeneralRoiTrophiesContentTrophyModalLayout>
      <:content>
        <div class="flex flex-col items-center gap-300">
          <div>
            <div class="heading-1">
              <GeneralRoiTrophiesCountUpNumber
                @currency={{this.currency}}
                @target={{this.data.revenue}}
              />
            </div>
            <div
              class="inline-flex items-center gap-100"
              data-test-id="revenue-general-subline"
            >
              {{t this.sublineKey}}
              <GeneralRoiTrophiesCalendarDateLink @highlight={{@highlight}} />
            </div>
          </div>
          <p class="text-300--regular text-neutral-subdued">{{t
              "roi_trophies.revenue_general.body"
            }}</p>
        </div>
      </:content>
      <:animation>
        <div
          {{lottieAnimation
            (importAsset "animations/roi-trophies/record.json")
            false
          }}
        />
      </:animation>
    </GeneralRoiTrophiesContentTrophyModalLayout>
  </template>
}
